module.exports = __webpack_public_path__ + "assets/img/4k@2x.7467b05f.png";